import { __decorate } from "tslib";
import { AutoEncoder, field, IntegerDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from 'uuid';
import { upgradePriceFrom2To4DecimalPlaces } from './upgradePriceFrom2To4DecimalPlaces.js';
export class GenericBalance extends AutoEncoder {
    id;
    /**
     * The organization that should receive the outstanding balance
     */
    organizationId;
    amountPaid = 0;
    amountOpen = 0;
    amountPending = 0;
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], GenericBalance.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], GenericBalance.prototype, "organizationId", void 0);
__decorate([
    field({ decoder: IntegerDecoder, version: 354 }),
    field({ ...upgradePriceFrom2To4DecimalPlaces })
], GenericBalance.prototype, "amountPaid", void 0);
__decorate([
    field({ decoder: IntegerDecoder, field: 'amount' }),
    field({ decoder: IntegerDecoder, version: 354 }),
    field({ ...upgradePriceFrom2To4DecimalPlaces })
], GenericBalance.prototype, "amountOpen", void 0);
__decorate([
    field({ decoder: IntegerDecoder }),
    field({ ...upgradePriceFrom2To4DecimalPlaces })
], GenericBalance.prototype, "amountPending", void 0);
//# sourceMappingURL=GenericBalance.js.map